import React, { useEffect, useState } from 'react';

import {
  CarouselReducerAction,
  CarouselReducerState,
} from '../../CarouselReducer';
import { RequiredCarouselControlArrows } from '../../CarouselInterfaces';

import { NextArrow, PreviousArrow } from '../arrow';
import { useBemBlockClassNames } from '../../hooks/useBemClassNames';

interface ArrowsProps {
  /**
   * Component global class
   */
  componentClass?: string;
  /**
   * Current selected slide index
   */
  carouselState: CarouselReducerState;
  /**
   * Define if the Carousel is infinite
   */
  isInfinite: boolean;
  /**
   * Arrows settings
   */
  settings: RequiredCarouselControlArrows;
  /**
   * Carousel global event dispatcher
   **/
  carouselDispatch: (action: CarouselReducerAction) => void;
}

const Arrows = ({
  componentClass = 'arrows-list',
  carouselDispatch,
  isInfinite,
  settings,
  carouselState,
  ...props
}: ArrowsProps) => {
  const [mainClasses, setMainClasses] = useState<string[]>([]);

  useEffect(() => {
    const newMainClasses = [
      settings.classes?.component ? settings.classes.component : componentClass,
    ];
    if (settings.classes?.custom) {
      newMainClasses.push(settings.classes.custom);
    }
    setMainClasses(newMainClasses);
  }, [settings, componentClass]);

  const arrowsClasses = useBemBlockClassNames(mainClasses);

  return (
    <div {...props} className={`${arrowsClasses}`}>
      <PreviousArrow
        settings={settings}
        carouselDispatch={carouselDispatch}
        isHidden={!isInfinite && carouselState.currentSlideIndex <= 0}
        child={settings.items.children.previous}
      />
      <NextArrow
        settings={settings}
        carouselDispatch={carouselDispatch}
        isHidden={
          !isInfinite &&
          carouselState.currentSlideIndex >= carouselState.maxIndex
        }
        child={settings.items.children.next}
      />
    </div>
  );
};

export default Arrows;
